import { IProviderUpload, IUploadRequest, IUploadStatus, UploadProvider } from 'types/upload-status';

export const isUploadTerminal = (status: IUploadStatus): boolean =>
	['COMPLETED', 'INCOMPLETE', 'FAILED'].includes(status.stage);

export const getProviderUploads = (
	uploads: IUploadStatus[],
	requests: Partial<Record<UploadProvider, IUploadRequest>>
): Partial<Record<UploadProvider, IProviderUpload>> => {
	const result: Partial<Record<UploadProvider, IProviderUpload>> = {};
	uploads.forEach((status) => {
		const previous = result[status.provider]?.status;
		if (!previous || Date.parse(status.startedAt) >= Date.parse(previous.startedAt)) {
			result[status.provider] = { status };
		}
	});
	Object.values(requests).forEach((request) => {
		const status = result[request.provider]?.status;
		if (!status || status.uploadId === request.uploadId || request.previousUploadIds.includes(status.uploadId)) {
			result[request.provider] = {
				request,
				status: status?.uploadId === request.uploadId ? status : undefined,
			};
		}
	});
	return result;
};

export const isUploadBusy = ({ status, request }: IProviderUpload): boolean => {
	if (request?.state === 'pending') return true;
	if (status) return !isUploadTerminal(status);
	return request?.state === 'accepted';
};

export const hasUploadIssue = ({ status, request }: IProviderUpload): boolean =>
	status ? status.stage === 'FAILED' || status.stage === 'INCOMPLETE' || status.truncated : request?.state === 'error';
